import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "26",
  fill: "none",
  viewBox: "0 0 22 26"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5.976 25.155c-1.684 0-2.727-1.016-2.81-2.686L2.441 6.855H1.287a.94.94 0 0 1-.919-.932c0-.515.432-.932.919-.932h4.856v-1.6c0-1.643 1.072-2.659 2.811-2.659h4.064c1.753 0 2.825 1.016 2.825 2.658v1.6h4.87a.93.93 0 0 1 .919.933.92.92 0 0 1-.919.932h-1.14l-.724 15.6c-.084 1.67-1.155 2.7-2.811 2.7zM8.12 3.53v1.46h5.734V3.53c0-.571-.404-.947-.974-.947H9.107c-.584 0-.988.376-.988.947M6.157 23.29h9.672c.612 0 1.03-.417 1.058-1.043l.681-15.392H4.376l.738 15.392c.027.612.459 1.043 1.043 1.043m1.628-1.725c-.445 0-.751-.279-.765-.724L6.7 9.43c-.014-.431.306-.724.765-.724.446 0 .752.279.766.724l.32 11.411c.014.431-.292.724-.766.724m3.215 0c-.473 0-.793-.293-.793-.724V9.43c0-.431.32-.724.793-.724s.793.293.793.724V20.84c0 .431-.32.724-.793.724m3.229 0c-.474 0-.78-.293-.766-.724L13.77 9.43c.014-.431.32-.724.766-.724.473 0 .779.293.765.724l-.306 11.411c-.014.445-.334.724-.765.724"
    }, null, -1)
  ])))
}
export default { render: render }